<div *ngIf="!isError">
  <div class="progress-dialog-header">
    <h2 class="title" mat-dialog-title>
      {{dialogTitle}}
    </h2>
    <span *ngIf="isCompleted || isError" class="close-icon pi pi-times" mat-dialog-close></span>
  </div>

  <mat-dialog-content>
    <div fxLayout="row wrap" fxLayoutAlign="center">
      <div class="content-container">
        <div>
          <p class="mat-subtitle-1" fxLayoutAlign="center">
            {{ roundedSyncProgress }}% ...
          </p>
          <p>
            <span class="mat-body-strong">
              {{successSyncStep}} / {{syncStepCount}} {{ 'syncProgressBarDialog.unitOfDataSync' | translate }}:
            </span>
            <span class="mat-body">
              {{dialogDescription}}
            </span>
          </p>
        </div>
        <ul class="progress-bar-description" *ngFor="let item of DescriptionList">
          <li>{{item.description}}({{ item.successCount }}/{{ item.totalCount }})</li>
        </ul>
      </div>
    </div>
    <div class="sync-progress-bar">
      <mat-progress-bar mode="buffer" value="{{ roundedSyncProgress }}" bufferValue="{{syncStepProgress}}"></mat-progress-bar>
    </div>
  </mat-dialog-content>
</div>
